import axios from "axios";
import { getUserRole, setError, delError } from "Utils/helpers";
import { decrypt } from "Utils/helpers";

const clientAPIUris = ["/api/v1/statistics/"];

function selectAPIDestination(uri) {
  let apiUrl = process.env.REACT_APP_BASE_URL;
  for (let index = 0; index < clientAPIUris.length; index++) {
    const clientAPIUri = clientAPIUris[index];
    if (uri.indexOf(clientAPIUri) > -1) {
      apiUrl = process.env.REACT_APP_CLIENT_URL;
      break;
    }
  }
  return apiUrl;
}

function signout() {
  redirect("/login");
}

function redirect(path) {
  if (window.location.pathname == path) return;
  window.location.replace(path);
}

function mainErrorHandler(error, uri) {
  setError(error);
  if (error.code == "ERR_NETWORK") redirect("/networkError");
  if (error.response && error.response.status === 401 && uri != "/api/v1/users/auth") signout();
  if (error.response && error.response.status === 403) signout();
}

function responseHandler(response) {
  if (response.data && response.data.encrypted) {
    let decryptedData = decrypt(response.data);
    if (decryptedData) response.data = JSON.parse(decryptedData);
  }

  return response;
}

export async function getConstantData(uri, headers = {}, errorHandler, abortController) {
  try {
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    let userRole = getUserRole();
    let apiUrl = selectAPIDestination(uri);
    delError("error");

    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.get(apiUrl + uri, axiosConfig);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    mainErrorHandler(err, uri);
    return null;
  }
}

export async function authenticate(uri, payload = {}, headers = {}, errorHandler, abortController) {
  try {
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    let apiUrl = process.env.REACT_APP_AUTH_URL;
    delError("error");

    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.post(apiUrl + uri, payload, axiosConfig);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    mainErrorHandler(err, uri);
    return null;
  }
}

export async function getData(uri, headers = {}, errorHandler, abortController) {
  try {
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    // const userRoles = getUserRole();
    // let userRolesIds = [];
    // for (const key in userRoles) {
    //   if (Object.hasOwnProperty.call(userRoles, key)) {
    //     const role = userRoles[key];
    //     userRolesIds.push(role.id);
    //   }
    // }
    let apiUrl = selectAPIDestination(uri);
    delError("error");

    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.get(apiUrl + uri, axiosConfig);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    mainErrorHandler(err, uri);
    return null;
  }
}

export async function postData(uri, payload = {}, headers = {}, errorHandler, abortController) {
  try {
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    // let userRole = getUserRole();
    let apiUrl = selectAPIDestination(uri);
    delError("error");

    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.post(apiUrl + uri, payload, axiosConfig);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    mainErrorHandler(err, uri);
    return null;
  }
}

export async function putData(uri, payload = {}, headers = {}, errorHandler, abortController) {
  try {
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    // let userRole = getUserRole();
    let apiUrl = selectAPIDestination(uri);
    delError("error");

    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.put(apiUrl + uri, payload, axiosConfig);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    mainErrorHandler(err, uri);
    return null;
  }
}

export async function delData(uri, headers = {}, errorHandler, abortController) {
  try {
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    // let userRole = getUserRole();
    let apiUrl = selectAPIDestination(uri);
    delError("error");

    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.delete(apiUrl + uri, axiosConfig);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    mainErrorHandler(err, uri);
    return null;
  }
}

export async function uploadData(
  uri,
  payload = {},
  headers = {},
  cb = {},
  errorHandler,
  abortController
) {
  try {
    headers["Content-Type"] = "multipart/form-data";
    headers["Access-Control-Allow-Origin"] = "*";
    // let userRole = getUserRole();
    let apiUrl = selectAPIDestination(uri);
    delError("error");

    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.post(apiUrl + uri, payload, axiosConfig, cb);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    mainErrorHandler(err, uri);
    return null;
  }
}

export async function generalGetData(
  url,
  headers = {},
  payload = {},
  cb = {},
  errorHandler,
  abortController
) {
  try {
    let axiosConfig = {};
    axiosConfig.headers = headers ? headers : {};
    axiosConfig.signal = abortController ? abortController.signal : null;

    let response = await axios.get(url, axiosConfig);
    return responseHandler(response);
  } catch (err) {
    if (errorHandler) {
      errorHandler(err);
      return;
    }
    return null;
  }
}
